import { AnnotationChildItem } from './annotation-child.model';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IAnnotationsAsset {
  _id: string;
  name: string;
  versions: IAnnotationsAssetVersion[];
}

export interface IAnnotationsAssetVersion {
  _id: string;
  name: string;
  version: number;
}

export interface IAnnotationsAssetVersion {
  _id: string;
  name: string;
  annotations: any[];
  annotationsCount: number;
}

export interface IAnnotationsAssetVersionAnnotations {
  attrs: any;
  className: string;
  children: AnnotationChildItem[];
}

export enum desiredActionsOnAnnotations {
  'createComment',
  'updateComment',
  'deleteComment',
  'createReply',
  'updateReply',
  'deleteReply',
}
